import mixpanel from "mixpanel-browser";

// Any function requiring the agency parameter only
export const mixPanelAgencyOnly = (agency: string, name: string, points: number) => {
  try {
    // Send information to Mixpanel
    mixpanel.track(name, {
      site: agency,
    });
    mixpanel.people.increment({
      "GOGOV Points": points,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
